module.exports = __webpack_public_path__ + "img/logo_aimm_color.png?7223c91aa2359fe4246c069d2ed2e4fa";